export default ($resource) => {
    const url = `${SEED_CORE.ENV.API_URL}course/history/:id`;
    return $resource(url, null, {
        occurrenceCreate: {
            method: 'POST',
            url: `${url}/occurrence-create`
        }
    });
};



// WEBPACK FOOTER //
// ./src/app/resources/CourseHistory/index.js